import { LOCALES } from 'i18n/locales';
export const autoLogoutIntl = {
    [LOCALES.ENGLISH]: {
        'autoLogout.inactivity': 'Your session will expire in 1 minute due to inactivity.',
        'autoLogout.continue': 'Please press OK to continue working.',
        'autoLogout.button.ariaLabel': 'Click to continue working'
    },
    [LOCALES.WELSH]: {
        'autoLogout.inactivity': 'Bydd eich sesiwn yn dod i ben mewn 1 munud oherwydd diffyg gweithgarwch',
        'autoLogout.continue': 'Pwyswch ar OK i barhau i weithio.',
        'autoLogout.button.ariaLabel': 'Cliciwch i barhau i weithio'
    }
};
